export const WORKSPACE_ITEM_HEIGHT = 38;
